module.exports = __webpack_public_path__ + "static/media/buses-icon-blue.958d9ae7.PNG";